import update from 'immutability-helper'
import * as t from './actionTypes'

/**
 * DEPRECATED. Use `entityReducer.js` instead.
 *
 * Using this file is deprecated. All logic should be moved to `entityReducer.js`.
 */
const initialState = {
  objects: {},
  uniqueKey: undefined,
  initialized: false,
  isLoading: true
}

// Temporary state for offers.
const entities = (state = initialState, action) => {
  // if (action.booking && action.booking.entities) {
  //   return merge({}, state, action.booking.entities);
  // }

  // if (action.type === 'offers') {
  //   return update(state, { offers: { $set: action.payload }, uniqueKey: { $set: action.uniqueKey ? action.uniqueKey : '' } });
  // }
  switch (action.type) {
    case t.SET_BOOKING: {
      return update(state, {
        [action.bookingType]: {
          $set: action.payload
        }
      })
    }
    case t.SET_IS_LOADING: {
      return update(state, {
        isLoading: {
          $set: action.payload
        }
      })
    }
    default:
      break
  }

  return state
}

export default entities
